import React, {useEffect, useState} from "react"
import {Helmet} from "react-helmet"
import logo404 from "../assets/images/404.svg"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import {useNavigate} from "react-router"

const Page404notFound = () => {
  const navigate = useNavigate()
  const [seconds, setSeconds] = useState(3)

  setTimeout(() => {
    let counter = seconds - 1
    setSeconds(counter)
    if (seconds < 1) {
      navigate("/")
    }
  }, 1000)

  //   const navigate = useNavigate();
  //   navigate('/error404', { replace: true, state: { status: 404 } });

  //   return null;
  // }
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_API}/error404`)
  }, [])

  return (
    <>
      <Helmet>
        <title>Error 404 | Tensolite</title>
      </Helmet>
      {/* SOLO PARA MAQUETA */}
      <div id="maqueta" className="bg-fullpage bg-404">
        <div className="card-info">
          <div className="cuadrado-azul"></div>
          <h1>Error 404 - Esta página no fue encontrada</h1>
          <p>
            Esta página no existe, verificar sdsdafla dirección ingresadaaaaaa.
          </p>
          <img alt="Imagen de error Tensolite" src={logo404}></img>
          <button className="settings_button-pleno bg-p-secondary mt-3 float-end">
            <a className="d-flex justify-content-center align-items-center" href="/">
              Volver al sitio principal en {seconds} <ArrowForwardIcon />
            </a>
          </button>
        </div>
      </div>
      {/* fin SOLO PARA MAQUETA */}
    </>
  )
}

export default Page404notFound
